import { useCallback, useContext } from 'react';

import { Position, Severity, Variant } from '../app/components/ToastMessage/toastMessageTypes';
// Нарочно от `toastContextValue`, а не от `ToastContext`: вторият тегли провайдъра,
// а с него `ToastMessage → Toast`. Виж коментара в toastContextValue.js.
import { ToastContext } from '../contexts/toastContextValue';

export type SystemAlertProps = {
  msg: string;
  variant?: Variant;
  severity?: Severity;
  title?: string;
  xIcon?: boolean;
  icon?: boolean;
  position?: Position;
  maxAlerts?: number;
  persistent?: boolean;
};

export default function useToastMessage() {
  const contextValue = useContext(ToastContext);
  const setSystemMessage = contextValue?.toastContext?.system_messages?.set;

  const setSystemAlert = useCallback(
    ({
      msg,
      variant = 'filled',
      severity = 'success',
      title = '',
      icon = false,
      xIcon = false,
      position = 'bottomRight',
      maxAlerts = 1,
      persistent,
    }: SystemAlertProps) => {
      if (typeof setSystemMessage !== 'function') {
        if (process.env.NODE_ENV === 'development') {
          console.warn('[useToastMessage] ToastProvider липсва в дървото:', msg);
        }
        return;
      }

      const newMessage = {
        id: Date.now(),
        title,
        msg,
        variant,
        severity,
        maxAlerts,
        xIcon,
        icon,
        position,
        persistent,
      };

      setSystemMessage(newMessage);
      return newMessage;
    },
    [setSystemMessage],
  );

  return setSystemAlert;
}
